import React from "react";
import { TypingAnimation } from "./TypingAnimation";

export const Header = ({ data, ui }) => {
  return (
    <header id="header" className="hero-redesign">
      <div className="hero-glow hero-glow-left" aria-hidden="true"></div>
      <div className="hero-glow hero-glow-right" aria-hidden="true"></div>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 intro-text">
                <h1 className="hero-title">
                  <span className="hero-title-main">
                    {data ? data.title : ui?.loading}
                  </span>
                  <span className="hero-title-spark" aria-hidden="true">
                    ✦
                  </span>
                </h1>
                <p className="hero-kicker">
                  {data
                    ? data.paragraph
                    : "Type less. Document better."}
                </p>
                {data?.subparagraph && (
                  <p className="hero-subtitle">{data.subparagraph}</p>
                )}
                <div className="hero-cta-group">
                  <a
                    className="btn btn-custom btn-lg hero-btn-primary"
                    href="/playground"
                  >
                    {ui?.playground}
                  </a>
                </div>
                <div className="typing-wrapper hero-typing">
                  <TypingAnimation
                    phrases={data?.typingAnimation?.phrases}
                    suggestions={data?.typingAnimation?.suggestions}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
